<template>
  <div class="sign-in-form" @keypress.enter="attemptLogin">
    <div class="a-container-form">
      <div class="a-label">{{$t('login-field')}}:</div>
      <div style="width:100%">
        <input type="text" class="a-input" name="login" :placeholder="$t('login-field-placeholder')" v-model.trim="$v.login.$model">
        <small v-if="$v.login.$dirty && !$v.login.required">{{$t('validation-error.email-or-phone-should-be-specified')}}</small>
        <small v-else-if="$v.login.$dirty && !$v.login.emailOrPhone">{{$t('validation-error.invalid-format')}}</small>
      </div>
    </div>
    <div class="a-container-form ">
      <div class="a-label">{{$t('password-field')}}:</div>
      <div style="width:100%">
        <input type="password" class="a-input" name="password" :placeholder="$t('password-field-placeholder')" v-model.trim="$v.password.$model">
        <small v-if="$v.password.$dirty && !$v.password.required">{{$t('validation-error.password-should-be-specified')}}</small>
        <small v-if="$v.password.$dirty && !$v.password.minLength">{{$tc('validation-error.password-should-contain-more-than-n-symbols', $v.password.$params.minLength.min)}}</small>
      </div>
    </div>
    <div class="a-container-form" v-if="!$v.password.$dirty && error && (error.ACCESS_DENIED || error.INVALID_PASSWORD)">{{$t('validation-error.email-or-password-are-invalid')}}</div>
    <div class="a-container-form" v-if="!$v.password.$dirty && error && error.TOO_MANY_REQUESTS">{{$t('validation-error.too-many-attempts-repeat-in-30-seconds')}}</div>
    <div class="a-container-form" v-if="!$v.password.$dirty && error && error.UNKNOWN">{{$t('errors.unknown')}}</div>

    <div class="a-group-btn__left">
      <button class="gui-btn gui-btn--link" @click.prevent="attemptLogin">{{$t('buttons.sign-in')}}</button>
      <button class="gui-btn gui-btn--link" type="button" data-toggle="modal" @click="showRecoveryPasswordDialog" v-t="'recovery-password'"></button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import RecoveryPasswordModal from './RecoveryPasswordModal'
  import { required, minLength, email, or, phone } from '@//validators'
  import api from '@/api'

  export default {
    components: {
      RecoveryPasswordModal
    },
    data: () => {
      return {
        login: null,
        password: null,
        isSigninFormVisible: false,
        isRecoveryPasswordVisible: false,
        error: undefined
      }
    },
    methods: {
      showRecoveryPasswordDialog() {
        const Dialog = Vue.extend(RecoveryPasswordModal)
        const instance = new Dialog({
          parent: this
        });

        instance.$on('close', () => {
          instance.$el.parentNode.removeChild(instance.$el);
          instance.$destroy();
        });

        instance.$mount();
        document.body.appendChild(instance.$el);
      },

      async attemptLogin() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runBlockerAction(async () => {
          try {
            this.error = undefined;

            await this.$store.dispatch('login', {
              login: this.login,
              password: this.password
            });
          }
          catch (e) {
            this.$v.$reset();

            if (!e instanceof api.Errors) {
              console.error('Unable to log in due to unexpected error', e)
              this.error = new api.Errors(api.Errors.UNKNOWN);
            }
            else if (e == api.Errors.ACCESS_DENIED || e == api.Errors.INVALID_PASSWORD) {
              this.error = e;
            }
            else if (e == api.Errors.TOO_MANY_REQUESTS) {
              this.error = e;
            }
            else {
              console.warn('unknown error');
              this.error = new api.Errors(api.Errors.UNKNOWN);
            }
          }
        });
      }
    },
    validations: {
      login: {
        required,
        emailOrPhone: or(email, phone),
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sign-in-form {
    width: 400px;
    padding: 10px;

    .a-label {
      max-width: 88px
    }

    @media only screen and (max-width: 460px) {
      width: 240px;

      .a-container-form{
        flex-wrap: wrap;
        padding-bottom: 24px;
      }
      .a-label{
        padding-bottom: 12px;
        max-width: 100%;
      }
    }

    @media only screen and (max-width: 610px) {
      width: 280px;

      .a-container-form{
        flex-wrap: wrap;
        padding-bottom: 24px;
      }
      .a-label{
        padding-bottom: 12px;
        max-width: 100%;
      }
    }
  }


</style>
